import type { CreateUserPayload, IMembershipRepository } from '../repositories/IMembershipRepository.js';

export type CreateUserWithMembershipInput = CreateUserPayload;

export function createCreateUserWithMembershipUseCase(deps: { membershipRepository: IMembershipRepository }) {
  return (input: CreateUserWithMembershipInput) => deps.membershipRepository.createUserWithMembership(input);
}
